<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Staffs" title="Staff Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end mb-3">
						<i class='bx bx-chevrons-left'></i> Back
					</a>
				</div>
			</div>

			<!-- Staff info -->
			<div class="card mb-4" v-if="staff_name || staff_email || staff_mobile">
				<div class="card-body">
					<h5 class="card-title">Staff Information</h5>
					<div class="row">
						<div class="col-md-4"><strong>Name:</strong> {{ staff_name || '-' }}</div>
						<div class="col-md-4"><strong>Email:</strong> {{ staff_email || '-' }}</div>
						<div class="col-md-4"><strong>Mobile:</strong> {{ staff_mobile || '-' }}</div>
					</div>
				</div>
			</div>

			<div class="card">
				<div class="card-body">
					<div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-4 d-flex align-items-end" style="margin-top: 32px;">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="limit" @change="fetchStaffLogs()">
										<option value="10">10</option>
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="100">100</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							<div class="col-md-2">
								<label class="control-label">Log Type</label>
								<select class="form-select" v-model="log_type" @change="fetchStaffLogs()">
									<option value="">All</option>
									<option value="1">Renewal</option>
									<option value="2">Service</option>
									<option value="3">Support</option>
									<option value="4">Tag</option>
								</select>
							</div>
							<!-- <div class="col-md-2">
								<label class="control-label">Type</label>
								<select class="form-select" v-model="renewal_type" @change="fetchStaffLogs()" :disabled="log_type === '2' || log_type === '3'">
									<option value="">All Types</option>
									<option value="1">Renewal</option>
									<option value="2">Enquiry</option>
									<option value="3">Recharge Request</option>
									<option value="4">Assign Recharge</option>
									<option value="5">Recharge Completed</option>
									<option value="6">Customer Info</option>
									<option value="7">Dealer Info</option>
									<option value="10">RechargeRequest Viewed</option>
									<option value="11">Extension</option>
									<option value="12">Replacement</option>
									<option value="15">Topup Request</option>
									<option value="16">Topup Completed</option>
								</select>
							</div> -->
							<div class="col-md-2">
								<label class="control-label">From Date</label>
								<input
									class="form-control"
									type="date"
									v-model="from_date"
									:max="maxDate"
									@change="fetchStaffLogs()"
								/>
							</div>
							<div class="col-md-2">
								<label class="control-label">To Date</label>
								<input
									class="form-control"
									type="date"
									v-model="to_date"
									:max="maxDate"
									@change="fetchStaffLogs()"
								/>
							</div>
							<div class="col-md-2" style="margin-top: 32px;">
								<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="onKeywordSearch"/>
							</div>
						</div>
					</div>

					<div class="table-responsive product-table">
						<table class="display" id="staff-log-table">
							<thead>
								<tr align="center">
									<th>Sl.No</th>
									<th>Log Date</th>
									<th>Log Type</th>
									<th>Status</th>
									<th>Remarks</th>
									<th>IMEI</th>
								</tr>
							</thead>
							<tbody v-if="staff_logs.length">
								<tr v-for="(log, index) in staff_logs" :key="log.log_type + '-' + log.id" align="center">
									<td>{{ (from - 1) + index + 1 }}</td>
									<td>{{ log.converted_created_at }}</td>
									<td>
										<span class="badge rounded-pill" :class="sourceLogTypeBadgeClass(log.log_type)">
											{{ sourceLogLabel(log) }}
										</span>
									</td>
									<td>
										<template v-if="log.log_type == 1">
											<span v-if="log.status == 1" class="badge rounded-pill bg-warning">Pending</span>
											<span v-else-if="log.status == 2" class="badge rounded-pill bg-success">Completed</span>
											<span v-else class="badge rounded-pill bg-secondary">{{ log.status }}</span>
										</template>
										<template v-else-if="log.log_type == 2">
											<span class="badge rounded-pill bg-secondary">{{ workServiceStatusLabel(log.status) }}</span>
										</template>
										<template v-else-if="log.log_type == 3">
											<span class="badge rounded-pill bg-secondary">{{ supportStatusLabel(log.status) }}</span>
										</template>
										<template v-else-if="log.log_type == 4">
											<span v-if="log.status == 1" class="badge rounded-pill bg-success">Tagged</span>
											<span v-else-if="log.status == 2" class="badge rounded-pill bg-warning">Untagged</span>
											<span v-else class="badge rounded-pill bg-secondary">{{ tagStatusLabel(log.status) }}</span>
										</template>
										<span v-else class="badge rounded-pill bg-secondary">{{ log.status }}</span>
									</td>
									<td>{{ log.remarks || '-' }}</td>
									<td>{{ log.imei || '-' }}</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="6" align="center">No logs available</td>
								</tr>
							</tbody>
						</table>
					</div>

					<caption v-if="staff_logs.length" class="float-start mt-2 d-block d-lg-inline">
						Showing {{ from }} to {{ to }} of {{ total }} entries
					</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end" v-if="pagination.length">
						<ul class="pagination">
							<li
								class="page-item"
								v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
								v-for="(page, index) in pagination"
								:key="page.label"
							>
								<a
									class="page-link"
									href="#"
									@click.prevent="fetchStaffLogs(buildPageUrl(page.url))"
									tabindex="-1"
								>
									<span v-if="index === 0">Prev</span>
									<span v-else-if="index === pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Staff Logs",

	data() {
		const today = new Date().toISOString().slice(0, 10);
		return {
			token: "",
			staff_id: null,
			staff_name: "",
			staff_email: "",
			staff_mobile: "",
			staff_logs: [],
			pagination: [],
			from: 0,
			to: 0,
			total: 0,
			limit: 20,
			keyword: "",
			from_date: today,
			to_date: today,
			keywordTimer: null,
			active_page_url: null,
			loading: false,
			log_type: "",
			renewal_type: "",
		};
	},

	computed: {
		maxDate() {
			return new Date().toISOString().slice(0, 10);
		},
	},

	mounted() {
		this.staff_id = this.$route.params.id;
		if (!this.staff_id) {
			this.$swal("", "Staff ID is required", "error").then(() => this.$router.go(-1));
			return;
		}
		this.getToken();
		this.fetchStaffLogs();
	},

	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
					this.user = airotrack_staff;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		appendCommonParams(params) {
			params.append("staff_id", this.staff_id);
			params.append("limit", this.limit);
			params.append("from_date", this.from_date || this.maxDate);
			params.append("to_date", this.to_date || this.maxDate);
			if (this.keyword && this.keyword.trim()) {
				params.append("keyword", this.keyword.trim());
			}
			if (this.log_type !== "" && this.log_type != null) {
				params.append("log_type", this.log_type);
			}
			if (this.renewal_type && this.renewal_type.trim() && (this.log_type === "" || this.log_type === "1")) {
				params.append("renewal_type", this.renewal_type.trim());
			}
		},

		buildQueryString(pageUrl = null) {
			const params = new URLSearchParams();
			this.appendCommonParams(params);
			if (pageUrl) {
				const pageMatch = pageUrl.match(/[?&]page=(\d+)/);
				if (pageMatch) {
					params.append("page", pageMatch[1]);
				}
			}
			return "/staffs/staffLogs?" + params.toString();
		},

		buildPageUrl(paginationPageUrl) {
			if (!paginationPageUrl) return this.buildQueryString();
			const pageMatch = paginationPageUrl.match(/[?&]page=(\d+)/);
			const params = new URLSearchParams();
			this.appendCommonParams(params);
			if (pageMatch) {
				params.append("page", pageMatch[1]);
			}
			return "/staffs/staffLogs?" + params.toString();
		},

		onKeywordSearch() {
			if (this.keywordTimer) clearTimeout(this.keywordTimer);
			this.keywordTimer = setTimeout(() => {
				this.fetchStaffLogs();
				this.keywordTimer = null;
			}, 400);
		},

		fetchStaffLogs(page_url = null) {
			this.getToken();
			const url = this.buildQueryString();
			page_url = page_url || url;
			this.active_page_url = page_url;
			this.loading = true;

			this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const data = res.data.data;
					if (res.data.status && data) {
						this.staff_name = data.staff_name || "";
						this.staff_email = data.staff_email || "";
						this.staff_mobile = data.staff_mobile || "";
						const logs = data.staff_logs;
						if (logs && logs.data) {
							this.staff_logs = logs.data;
							this.pagination = logs.links || [];
							this.from = logs.from ?? 0;
							this.to = logs.to ?? 0;
							this.total = logs.total ?? 0;
						} else {
							this.staff_logs = [];
							this.pagination = [];
							this.from = 0;
							this.to = 0;
							this.total = 0;
						}
					} else {
						this.staff_name = "";
						this.staff_email = "";
						this.staff_mobile = "";
						this.staff_logs = [];
						this.pagination = [];
						this.from = 0;
						this.to = 0;
						this.total = 0;
					}
				})
				.catch((err) => {
					console.log(err);
					this.staff_name = "";
					this.staff_email = "";
					this.staff_mobile = "";
					this.staff_logs = [];
					this.pagination = [];
					this.from = 0;
					this.to = 0;
					this.total = 0;
				})
				.finally(() => {
					this.loading = false;
				});
		},

		sourceLogTypeLabel(logType) {
			const map = {
				1: "Renewal",
				2: "Service",
				3: "Support",
				4: "Tag",
			};
			return map[logType] || "-";
		},

		sourceLogLabel(log) {
			if (log.log_type == 1 && log.type == 5) {
				return "Extension";
			}
			return this.sourceLogTypeLabel(log.log_type);
		},

		sourceLogTypeBadgeClass(logType) {
			const map = {
				1: "bg-primary",
				2: "bg-secondary",
				3: "bg-info",
				4: "bg-warning",
			};
			return map[logType] || "bg-secondary";
		},

		typeLabel(log) {
			if (log.log_type == 1) {
				return this.renewalTypeLabel(log.type);
			}
			if (log.log_type == 2) {
				return this.workServiceStatusLabel(log.type);
			}
			if (log.log_type == 3) {
				return this.supportStatusLabel(log.type);
			}
			if (log.log_type == 4) {
				return this.tagStatusLabel(log.type);
			}
			return "-";
		},

		renewalTypeLabel(type) {
			const map = {
				1: "Renewal",
				2: "Enquiry",
				3: "Recharge Request",
				4: "Assign Recharge",
				5: "Recharge Completed",
				6: "Customer Info",
				7: "Dealer Info",
				8: "Payment Received",
				9: "To Safe Custody",
				10: "RechargeRequest Viewed",
				11: "Extension",
				12: "Replacement",
				13: "Revoke",
				14: "Update",
				15: "Topup Request",
				16: "Topup Completed",
			};
			return map[type] != null ? map[type] : (type != null ? "Type " + type : "-");
		},

		workServiceStatusLabel(status) {
			const map = {
				1: "Pending",
				2: "Ongoing",
				3: "Completed",
				4: "To Vendor",
				5: "Component Replacement",
				6: "SIM Change",
				7: "Device Replaced",
				8: "Payment",
				9: "Revoke",
				10: "Update",
			};
			return map[status] != null ? map[status] : (status != null ? "Status " + status : "-");
		},

		supportStatusLabel(status) {
			const map = {
				1: "Pending",
				2: "Ongoing",
				3: "Completed",
				4: "To Speedtech",
				5: "To Technician",
				6: "To Service",
			};
			return map[status] != null ? map[status] : (status != null ? "Status " + status : "-");
		},

		tagStatusLabel(status) {
			const map = {
				1: "Tagged",
				2: "Untagged",
			};
			return map[status] != null ? map[status] : (status != null ? "Status " + status : "-");
		},
	},
};
</script>
